import { use, useEffect } from 'react';

import { setRecentlyViewedClubIdForKey } from 'src/components/layout/redesign/header-shared/promo-helper';
import { SiteContext } from 'src/context/site-context';
import { RecentlyViewedClubStorageKey } from 'src/helpers/recently-viewed-club-storage-keys';

const useRegisterClubAsLastViewed = (clubId: string) => {
  const { untranslatedPath } = use(SiteContext);
  const isClubPagePath = !!untranslatedPath && /^\/clubs\/(?!$)/.test(untranslatedPath);

  useEffect(() => {
    // Sanity check
    if (!isClubPagePath) return;

    setRecentlyViewedClubIdForKey(RecentlyViewedClubStorageKey.clubId, clubId);
    setRecentlyViewedClubIdForKey(RecentlyViewedClubStorageKey.searchClubId, clubId);
  }, [clubId, isClubPagePath]);
};

export default useRegisterClubAsLastViewed;
